import Vue from 'vue'
import VueRouter from 'vue-router'

import DecorationAgreement from '../views/DecorationAgreement.vue'
import EmployeePrivacyPolicy from '../views/EmployeePrivacyPolicy.vue'
import EmployeeUserAgreement from '../views/EmployeeUserAgreement.vue'
import FireSafetyCommitment from '../views/FireSafetyCommitment.vue'
import Home from '../views/Home.vue'
import ParkingAgreement from '../views/ParkingAgreement.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import UserAgreement from '../views/UserAgreement.vue'
import Share from '../views/Share.vue'
import ShareNew from '../views/ShareNew.vue'
import LklBack from '../views/LklBack.vue'
import Invited from '../views/Invited.vue'
import Registration from '../views/Registration.vue'
import Carsarchiv from '../views/Carsarchiv.vue'
import Payment from '../views/Payment.vue'
import Questionnaire from '../views/Questionnaire.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: {
      title: '临时停车缴费'
    }
  },
  {
    path: '/privacy-policy',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy,
    meta: {
      title: '悦享住隐私政策'
    }
  },
  {
    path: '/user-agreement',
    name: 'UserAgreement',
    component: UserAgreement,
    meta: {
      title: '悦享住用户协议'
    }
  },
  {
    path: '/decoration-agreement',
    name: 'DecorationAgreement',
    component: DecorationAgreement,
    meta: {
      title: '业主自行装修承诺书'
    }
  },
  {
    path: '/fire-safety-commitment',
    name: 'FireSafetyCommitment',
    component: FireSafetyCommitment,
    meta: {
      title: '装修消防安全承诺书'
    }
  },
  {
    path: '/parking-agreement',
    name: 'ParkingAgreement',
    component: ParkingAgreement,
    meta: {
      title: '停车场车位使用及车辆停放服务协议'
    }
  },
  {
    path: '/employee-privacy-policy',
    name: 'EmployeePrivacyPolicy',
    component: EmployeePrivacyPolicy,
    meta: {
      title: '憬悦管家隐私政策'
    }
  },
  {
    path: '/employee-user-agreement',
    name: 'EmployeeUserAgreement',
    component: EmployeeUserAgreement,
    meta: {
      title: '憬悦管家用户协议'
    }
  },
  {
    path: '/share',
    name: 'Share',
    component: Share,
    meta: {
      title: '景悦科技访客预约通行证'
    }
  },
  {
    path: '/shareNew',
    name: 'ShareNew',
    component: ShareNew,
    meta: {
      title: '景悦科技访客预约通行证'
    }
  },
  {
    path: '/lklBack',
    name: 'LklBack',
    component: LklBack,
    meta: {
      title: '电子签约'
    }
  },
  {
    path: '/invite',
    name: 'Invite',
    component: Invited,
    meta: {
      title: '邀请函'
    }
  },
  {
    path: '/registration',
    name: 'Registration',
    component: Registration,
    meta: {
      title: '人员登记'
    }
  },
  {
    path: '/carsarchiv',
    name: 'Carsarchiv',
    component: Carsarchiv,
    meta: {
      title: '车辆登记'
    }
  },
  {
    path: '/payment',
    name: 'Payment',
    component: Payment,
    meta: {
      title: '缴费单'
    }
  },
  {
    path: '/questionnaire',
    name: 'Questionnaire',
    component: Questionnaire,
    meta: {
      title: '问卷调查'
    }
  }
]

const router = new VueRouter({
  routes
})

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

export default router
